import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-stl-viewer-page',
  templateUrl: './stl-viewer-page.component.html',
  styleUrls: ['./stl-viewer-page.component.css']
})
export class StlViewerPageComponent implements OnInit {
  public stlUrl: string;
  public fileName: string;

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    const url = this.activatedRoute.snapshot.queryParams['url'];
    if (url && url.includes('aliwellstorageaccount.blob.core.windows.net')) {
      this.stlUrl = url;
      const parts = url.split('/');
      this.fileName = parts[parts.length - 1];
    }
  }
}
